@if (!showReadonlyView) {
  <div>
    <div class="form-group">
      @if (!hideLabel) {
        <label class="text-gray-dark flex"
          >{{ title! | translate }}&nbsp;
          @if (tooltip !== null) {
            <i-feather name="info" [ngbTooltip]="tooltip | translate"></i-feather>
          }
        </label>
      }
      <div class="input-group">
        @if (textMask) {
          <input
            [disabled]="disabled"
            (change)="onChange(value!)"
            type="text"
            class="form-control"
            [(ngModel)]="value"
            [mask]="textMask"
            (focusout)="isValid()"
            [ngClass]="{ 'input-error': validationErrors.length > 0, 'input-with-append': showRemove }"
            [attr.maxLength]="maxLength"
          />
        } @else {
          <input
            [disabled]="disabled"
            (change)="onChange(value!)"
            type="text"
            class="form-control"
            [(ngModel)]="value"
            (focusout)="isValid()"
            [ngClass]="{ 'input-error': validationErrors.length > 0, 'input-with-append': showRemove }"
            [attr.maxLength]="maxLength"
          />
        }
        @if (showRemove) {
          <div class="input-group-append">
            <button class="btn btn-input" (click)="removeClicked()" type="button">
              <i-feather name="x" style="height: 10px; display: inherit"></i-feather>
            </button>
          </div>
        }
      </div>
      @if (validationErrors.length > 0) {
        <div class="invalid-field">
          @for (error of validationErrors; track error) {
            <span> {{ error! | translate }} <br /> </span>
          }
        </div>
      }
    </div>
  </div>
}

@if (showReadonlyView) {
  <div>
    <div class="form-group read-only">
      <label class="text-gray-dark flex"
        >{{ title! | translate }}&nbsp;
        @if (readonlyTooltip !== null) {
          <i-feather name="info" [ngbTooltip]="readonlyTooltip | translate"> </i-feather>
        }
      </label>
      <div class="input-group">{{ value || '-' }}</div>
    </div>
  </div>
}
